import $ from 'jquery';

/* global x5script */

class Navigation {
  constructor() {
    this.nav = $('.js-nav');
    this.navToggler = $('.js-nav-toggler');
    this.mainNavLink = this.nav.find('.js-main-nav-link');
    this.homePageUrl = x5script.homePageUrl;

    this.mobileNavToggler();
    this.mobileNavDropdown();
    this.navToHome();
  }

  navToHome() {
    this.link = $('a');

    this.link.on('click', e => {
      const link = $(e.currentTarget);
      const hash = link.attr('href');

      if (hash.slice(0, 6) === '#home-') {
        e.preventDefault();
        const homeSectionId = `#${hash.slice(6)}`;

        window.location = `${this.homePageUrl}/${homeSectionId}`;
      }
    });
  }

  mobileNavToggler() {
    if (this.navToggler.length) {
      this.navToggler.on('click', e => {
        const toggler = $(e.currentTarget);
        const target = toggler.data('target');
        const nav = toggler.parent().find(`#${target}`);

        toggler
          .toggleClass('is-active')
          .attr('aria-expanded', toggler.hasClass('is-active'));

        if (nav.length) {
          if (nav.is(':visible')) {
            nav.css({ display: 'block' });
          }
          nav.slideToggle(400, () => {
            if (nav.is(':visible')) {
              nav.css({ display: 'flex' });
            } else {
              nav.css({ display: '' });
            }
          });
        }
      });
    }
  }

  mobileNavDropdown() {
    this.mainNavLink.on('click', e => {
      const target = $(e.target);

      if (target.hasClass('js-caret')) {
        e.preventDefault();
        const dropdown = target
          .closest('.js-main-nav-item')
          .find('.js-nav-dropdown')
          .first();

        if (dropdown.length) {
          const dropdowns = dropdown.find('.js-nav-dropdown');

          if (dropdowns.length) {
            dropdowns.show();
          }

          this.nav
            .find('.js-nav-dropdown')
            .not(dropdown)
            .slideUp();
          dropdown.slideToggle();
        }
      }
    });
  }
}

export default new Navigation();



// WEBPACK FOOTER //
// ./src/scripts/modules/navigation.js